import React from "react";

export const ConsignmentNotFound = ({ message }) => {
    return (
        <div className="Track py-4 px-3 w-100 d-flex flex-column justify-content-center h-100 flex-grow-1">
            <div className="shadow content-card w-100">
                <div className="bg-white rounded-top py-4 pt-md-5">
                    <img
                        src={require("../../assets/images/freight-people-logo-c.png")}
                        id="logo"
                        alt="Freight People"
                        className="fp-logo d-block mx-auto w-100"
                    />
                </div>
                <div
                    className="bg-primary rounded-bottom px-4 py-4 px-sm-5 pb-md-5 text-white
          text-center"
                >
                    <p className="font-weight-bold">{message}</p>
                    <p className="mb-4">
                        You have entered an incorrect Tracking ID or Consignment ID. Please double check the Tracking ID
                        or contact our support team for more information.
                    </p>
                    <a
                        id="email-enquiry"
                        href="mailto:support@freightpeople.com.au?subject=Page%20not%20found%20error%20-%20Tracking%20ASN"
                        className="mx-auto btn-form-submit btn btn-secondary text-uppercase px-4 py-2"
                    >
                        Email enquiry
                    </a>
                </div>
            </div>
        </div>
    );
};
